import React from "react";
import classes from "./ApplicationsTabMenu.module.css";
import IconMenu from "./IconMenu";

function ApplicationsTabMenu({ menuList, props }) {
  return (
    <div className={classes.iconsGroup}>
      {menuList.map((menu) => {
        if (menu?.node) {
          return menu?.node;
        } else {
          return <IconMenu
            key={menu.id}
            popUpText={menu.popUpText}
            iconProps={{
              name: menu.iconName,
              size: "large",
              onClick: () => menu.actions.onClick(),
              // className: classes.icon,
            }}
          />
        }
      })}
    </div>
  );
}

export default ApplicationsTabMenu;
